var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "scheduleContainer" },
    [
      _vm._l(_vm.scheduleList, function(schedule) {
        return _c(
          "div",
          { key: schedule.id },
          [
            _c(
              "q-btn",
              {
                attrs: { disable: _vm.isHourSoldOut(schedule.id) },
                on: {
                  click: function($event) {
                    _vm.clickSelectHour(schedule)
                  }
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "btn-content" },
                  [
                    _c(
                      "span",
                      {
                        class: {
                          scheduleLabel: true,
                          longLabel: ("" + schedule.label).length > 5
                        }
                      },
                      [
                        _vm._v(
                          "\n          " + _vm._s(schedule.label) + "\n        "
                        )
                      ]
                    ),
                    _vm.showAvailability && schedule.available > 0
                      ? _c("availability-label", {
                          attrs: {
                            availability: schedule.available,
                            "last-tickets-max-qty": _vm.lastTicketsMaxQty
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ]
            ),
            _vm.isHourSoldOut(schedule.id)
              ? _c("sold-out-icon", { attrs: { "place-on-right-corner": "" } })
              : _vm.hourHasDiscount(schedule.id)
              ? _c("discount-icon", { attrs: { "place-on-right-corner": "" } })
              : _vm._e()
          ],
          1
        )
      }),
      _vm.hasAnyDiscount || _vm.hasAnySoldOut
        ? _c(
            "div",
            { staticClass: "legendWrapper" },
            [
              _c("calendar-legend", {
                attrs: {
                  discount: _vm.hasAnyDiscount,
                  "sold-out": _vm.hasAnySoldOut,
                  availability: _vm.showAvailability
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }